let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kklBl")).then(() => parcelRequire('eYo4p'));